<template>
  <div id="home">
    <el-container>
      <admin-menu  v-if="!isAdmin"></admin-menu>
      <base-header v-if="showHeaderAndFooter" :activeIndex="activeIndex"></base-header>

      <router-view :class="isAdmin?'me-container':'me-container-admin'" />

      <base-footer v-if="isAdmin && showHeaderAndFooter"></base-footer>
    </el-container>
    <!-- <feedback v-if="isAdmin"></feedback> -->
    <go-top v-if="isAdmin"></go-top>
    <customerService v-if="isAdmin"></customerService>
  </div>
</template>

<script>
import BaseFooter from "@/components/BaseFooter";
import BaseHeader from "@/views/BaseHeader";
import feedback from "@/components/feedback/feedback";
import GoTop from "@/components/gotop/GoTop";
import customerService from "@/components/customerService/customerService";
import AdminMenu from "@/components/admin/AdminMenu";
export default {
  name: "Home",
  data() {
    return {
      activeIndex: "/",
      footerShow: true,
      showHeaderAndFooter: true,
    };
  },
  components: {
    BaseHeader,
    BaseFooter,
    feedback,
    GoTop,
    customerService,
    AdminMenu
  },
  computed: {
    isAdmin() {
      if (this.$store.state.typeCode == 3 || this.$store.state.typeCode == 4) {
        return false;
      } else {
        return true;
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.activeIndex = to.path;
      if (to.path == '/socketMsg') {
        vm.showHeaderAndFooter = false
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    if (to.path == "/") {
      this.footerShow = true;
    } else {
      this.footerShow = false;
    }
    this.activeIndex = to.path;
    next();
  }
};
</script>

<style>
@media screen and (max-width: 992px) {
  .me-container {
    width: 92%!important;
  }
}
.el-container {

  min-height: 100vh;
}
.me-container {
  margin: 100px auto 200px;
  width: 1200px;
  position: relative;
}
.me-container-admin {
  margin: 100px auto 20px;
  position: relative;
}
.clearfix:before,
.clearfix:after {
  content: "";
  display: table;
}

.clearfix:after {
  clear: both;
}
.text-ofh {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mask {
  width: 100%;
  opacity: 0.6;
  background-color: black;
  bottom: 0;
  left: 0;
  position: fixed;
  z-index: 998;
  height: 100%;
}

::-webkit-scrollbar {
  width: 6px;

  background: transparent;
}

::-webkit-scrollbar-track {
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  border-radius: 3px;

  height: 100px;

  background-color: #ccc;
}

@media screen and (max-width:374px) {
  .me-container {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/Home.vue